import React from 'react';
import { Col, Row, Text } from 'components';
import { StyleSheet, Image } from 'react-native';
import { ASSETS } from 'assets';

const MSC_BLUE = '#004B8D';
const SUCCESS = '#1FA463';

interface HeaderProps {
  liveClock: string;
  lastUpdate: string;
}

const Header: React.FC<HeaderProps> = ({ liveClock, lastUpdate }) => {
  return (
    <Col style={styles.header}>
      <Row alignItems="center" justifyContent="space-between" flex1>
        <Row alignItems="center">
          <Image source={ASSETS.LOGO} style={styles.logo} resizeMode="contain" />
          <Col marginLeft={24}>
            <Text fontSize={28} bold color="white" style={{ letterSpacing: -0.5 }}>
              MSC OPERATIONS DASHBOARD
            </Text>
            <Text fontSize={14} color="#B3D9FF" medium marginTop={4}>
              Real-time Delivery Network Overview
            </Text>
          </Col>
        </Row>

        <Row alignItems="center">
          <Col marginRight={32} alignItems="flex-end">
            <Text fontSize={28} bold color="white">
              {liveClock}
            </Text>
            <Text fontSize={14} color="#B3D9FF" marginTop={4}>
              Last update: {lastUpdate}
            </Text>
          </Col>
          <Col style={styles.liveIndicator}>
            <Col style={styles.liveDot} />
            <Text fontSize={14} bold color="white" style={{ letterSpacing: 1 }}>
              LIVE CONNECTED
            </Text>
          </Col>
        </Row>
      </Row>
    </Col>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 96,
    backgroundColor: MSC_BLUE,
    paddingRight: 32,
    paddingLeft: 24,
    paddingVertical: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  headerIcon: {
    width: 64,
    height: 64,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 46 / 0.46,
    height: 46,
  },
  liveIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
  },
  liveDot: {
    width: 12,
    height: 12,
    backgroundColor: SUCCESS,
    borderRadius: 6,
    marginRight: 12,
    shadowColor: SUCCESS,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.8,
    shadowRadius: 4,
    elevation: 4,
  },
});

export default Header;

